import './Loader.css';
import logo from '../assets/autoboy_logo3.png';

const Loader = () => {
  return (
    <div className="AutoboyExpress-loader-container">
      <img src={logo} alt="AutoboyExpress" className="AutoboyExpress-loader-logo" />
    </div>
  );
};

export default Loader;
